import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { LOGOUT } from 'mocks/mutations';

import useUserData from 'data-hooks/useUserData';
import useLogoutClient from 'data-hooks/useUserData/useLogoutClient';
import CustomerDashboardPageTemplateUI from './CustomerDashboardPageTemplateUI';

const CustomerDashboardPageTemplate = ({
  children,
  parentPageItem,
  showBreadcrumb = true,
  showSidebar = true,
  showTitle = true,
  title,
  titleComponent = null,
}) => {
  const { email } = useUserData();
  const [logout] = useMutation(LOGOUT);
  const logoutClient = useLogoutClient();

  const onLogoutClick = async () => {
    await logout();
    logoutClient();
    window.location.replace('/');
  };

  return (
    <CustomerDashboardPageTemplateUI
      email={email}
      onLogoutClick={onLogoutClick}
      parentPageItem={parentPageItem}
      showBreadcrumb={showBreadcrumb}
      showSidebar={showSidebar}
      showTitle={showTitle}
      title={title}
      titleComponent={titleComponent}
    >
      {children}
    </CustomerDashboardPageTemplateUI>
  );
};

CustomerDashboardPageTemplate.propTypes = {
  children: PropTypes.node,
  parentPageItem: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  showBreadcrumb: PropTypes.bool,
  showSidebar: PropTypes.bool,
  showTitle: PropTypes.bool,
  title: PropTypes.string,
  titleComponent: PropTypes.string,
};

export default CustomerDashboardPageTemplate;
